import { UserModel } from 'types/models/dataAccess/User';
import {
WorkshopBookingObj, WorkshopObj,
} from 'types/models/home/HomeApp';

export const GET_SPACES_LIST = 'GET_SPACES_LIST';
export const SET_SPACE_DATA = 'SET_SPACE_DATA';
export const SET_MY_MACHINE_BOOKINGS_LIST = 'SET_MY_MACHINE_BOOKINGS_LIST';
export const SET_WORKSHOPS_LIST = 'SET_WORKSHOPS_LIST';
export const SET_RESOURCES_LIST = 'SET_RESOURCES_LIST';
export const SET_CURRENT_RESOURCE = 'SET_CURRENT_RESOURCE';
export const SET_CURRENT_WORKSHOP = 'SET_CURRENT_WORKSHOP';
export const SET_FILTER_DATA = 'SET_FILTER_DATA';
export const SET_INTAKE_COMPLETE = 'SET_INTAKE_COMPLETE';
export const SET_BOOKING_TYPE = 'SET_BOOKING_TYPE';
export const SET_CALENDAR_TYPE = 'SET_CALENDAR_TYPE';
export const SET_IS_BOOKING_OPEN = 'SET_IS_BOOKING_OPEN';
export const SET_IS_WORKSHOP_OPEN = 'SET_IS_WORKSHOP_OPEN';
export const SET_MY_WORKSHOP_BOOKINGS_LIST = 'SET_MY_WORKSHOP_BOOKINGS_LIST';
export const SET_MEMBERS_LIST = 'SET_MEMBERS_LIST';
export const SET_CURRENT_MEMBER = 'SET_CURRENT_MEMBER';
export const SET_MEMBER_REPORTS_LIST = 'SET_MEMBER_REPORTS_LIST';
export const SET_ALL_MACHINE_BOOKINGS_LIST = 'SET_ALL_MACHINE_BOOKINGS_LIST';
export const SET_COURSES_LIST = 'SET_COURSES_LIST';
export interface SetIntakeCompleteAction {
  type: typeof SET_INTAKE_COMPLETE;
  payload: any;
}

export interface SetResourceAction {
  type: typeof SET_CURRENT_RESOURCE;
  payload: any;
}


export interface SetCurrentWorkshopAction {
  type: typeof SET_CURRENT_WORKSHOP;
  payload: WorkshopObj | null;
}

export interface SetResourcesListAction {
  type: typeof SET_RESOURCES_LIST;
  payload: any[];
}


export interface SetCoursesListAction {
  type: typeof SET_COURSES_LIST;
  payload: any[];
}

export interface SetMyMachineBookingsListAction {
  type: typeof SET_MY_MACHINE_BOOKINGS_LIST;
  payload: any[];
}


export interface SetWorkshopsListAction {
  type: typeof SET_WORKSHOPS_LIST;
  payload: WorkshopObj[];
}


export interface SetFilterDataAction {
  type: typeof SET_FILTER_DATA;
  payload: any;
}


export interface GetSpacesAction {
  type: typeof GET_SPACES_LIST;
  payload: any[];
}

export interface SetSpaceDetailAction {
  type: typeof SET_SPACE_DATA;
  payload: any;
}

export interface SetBookingTypeAction {
  type: typeof SET_BOOKING_TYPE;
  payload: number;
}

export interface SetCalendarTypeAction {
  type: typeof SET_CALENDAR_TYPE;
  payload: number;
}

export interface SetBookingOpenTypeAction {
  type: typeof SET_IS_BOOKING_OPEN;
  payload: boolean;
}
export interface SetWorkshopOpenTypeAction {
  type: typeof SET_IS_WORKSHOP_OPEN;
  payload: boolean;
}

export interface SetWorkshopBookingsListAction {
  type: typeof SET_MY_WORKSHOP_BOOKINGS_LIST;
  payload: WorkshopBookingObj[];
}
export interface SetMembersListAction {
  type: typeof SET_MEMBERS_LIST;
  payload: UserModel[];
}
export interface SetCurrentMemberAction {
  type: typeof SET_CURRENT_MEMBER;
  payload: UserModel | null;
}
export interface SetMemberReportsListAction {
  type: typeof SET_MEMBER_REPORTS_LIST;
  payload: WorkshopObj[];
}

export interface SetAllMachineBookingsListAction {
  type: typeof SET_ALL_MACHINE_BOOKINGS_LIST;
  payload: any[];
}


export type HomeActionTypes =
  | GetSpacesAction
  | SetResourceAction
  | SetCurrentWorkshopAction
  | SetSpaceDetailAction
  | SetMyMachineBookingsListAction
  | SetResourcesListAction
  | SetFilterDataAction
  | SetIntakeCompleteAction
  | SetWorkshopsListAction
  | SetBookingTypeAction
  | SetCalendarTypeAction
  | SetWorkshopBookingsListAction
  | SetBookingOpenTypeAction
  | SetWorkshopOpenTypeAction
  | SetMembersListAction
  | SetCurrentMemberAction
  | SetMemberReportsListAction
  | SetAllMachineBookingsListAction
  | SetCoursesListAction;
